import { forwardRef, useState } from 'react'

import type { InputProps } from './Input'
import Input from './Input'
import Icon from './Icon'
import { Eye, EyeOff } from 'lucide-react'

export type PasswordInputProps = InputProps

const PasswordInput = forwardRef<HTMLInputElement, PasswordInputProps>((props, forwardRef) => {
    const [isVisible, setIsVisible] = useState(false)

    const onToggleVisibility = () => {
        setIsVisible((prev) => !prev)
    }

    return (
        <Input
            type={isVisible ? 'text' : 'password'}
            onRightIconClick={onToggleVisibility}
            rightIcon={<Icon icon={isVisible ? EyeOff : Eye} color="secondary" size="1" />}
            ref={forwardRef}
            {...props}
        />
    )
})

export default PasswordInput
